import { IS_DEV_ENV } from "./app.constants";

export const THEME_COLOR = "#000000";
export const THEME_FONT_FAMILY = "Bai Jamjuree";
export const MIDSTREAM_CHART_BACKGROUND_COLOUR = "#f4f6f6";
export const DEFAULT_FONT_SIZE = 12;

export const SUPPORTED_FONT_FAMILIES = [
  { value: THEME_FONT_FAMILY, label: "EVA (default)" },
  { value: "Arial", label: "Arial" },
  { value: "Bodoni", label: "Bodoni" },
  { value: "Calibri", label: "Calibri" },
  { value: "Franklin Gothic", label: "Franklin Gothic" },
  { value: "Garamond", label: "Garamond" },
  { value: "Palatino", label: "Palatino" },
  { value: "Segoe UI", label: "Segoe" },
  { value: "Tw Cen MT", label: "Tw Cen MT" },
  { value: "Verdana", label: "Verdana" }
];

if (IS_DEV_ENV) {
  SUPPORTED_FONT_FAMILIES.push({ value: "Wingdings", label: "Wingdings" });
}

// Resolves a stored fontFamily value to the CSS stack rendered in charts.
// Office fonts only exist on Windows, so each maps to an open-source substitute
// (loaded via Google Fonts — see scss/_typography.scss) listed first so the
// selection renders the same on every OS. Keys are the picker's stored values.
export const FONT_FAMILY_STACKS: StringMap<string> = {
  Bodoni: "'Bodoni Moda', Bodoni, serif",
  Calibri: "Carlito, Calibri, sans-serif",
  "Franklin Gothic": "'Libre Franklin', 'Franklin Gothic', sans-serif",
  Garamond: "'EB Garamond', Garamond, serif",
  "Segoe UI": "'Open Sans', 'Segoe UI', sans-serif",
  "Tw Cen MT": "Jost, 'Tw Cen MT', sans-serif",
  Arial: "Arial, Helvetica, sans-serif",
  Palatino: "Palatino, 'Palatino Linotype', 'Book Antiqua', serif",
  Verdana: "Verdana, Geneva, sans-serif"
};

/** Resolve a stored fontFamily value to the CSS font stack to render with. */
export const resolveFontFamily = (value?: Maybe<string>): string =>
  (value && FONT_FAMILY_STACKS[value]) || value || THEME_FONT_FAMILY;
